import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';

import { translation } from '@hh.ru/front-static-app';
import { IconColor, ArrowScaleSmallKindLeft } from 'bloko/blocks/icon';
import Link from 'bloko/blocks/link';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Logo from 'src/components/Logo';
import Menu from 'src/components/Menu';
import Profile from 'src/components/Profile';

import styles from 'src/components/Sidebar/sidebar.less';

const TrlKeys = {
    backToHH: 'statportal.backToHHLink',
};

const Sidebar: TranslatedComponent = ({ trls }) => {
    const [isOpen, setIsOpen] = useState(false);
    const sidebarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const hideSidebarByOutsideClick = ({ target }: Event): void => {
            if (sidebarRef.current && !sidebarRef.current.contains(target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', hideSidebarByOutsideClick);
        return () => {
            document.removeEventListener('click', hideSidebarByOutsideClick);
        };
    }, [sidebarRef]);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div
            className={classnames(styles.sidebar, {
                [styles.sidebarOpened]: isOpen,
            })}
            ref={sidebarRef}
            data-qa={classnames('sidebar', {
                sidebar_opened: isOpen, // eslint-disable-line camelcase
            })}
        >
            <div className={styles.sidebarLinkToMainSite}>
                <Link href="/" disableVisited={true}>
                    <span className={styles.sidebarLinkToMainSiteIcon}>
                        <ArrowScaleSmallKindLeft initial={IconColor.Blue40} />
                    </span>
                    {trls[TrlKeys.backToHH]}
                </Link>
            </div>
            <div className={styles.sidebarLogo}>
                <Logo isFull={isOpen} />
            </div>
            <button
                className={classnames(styles.sidebarButton, {
                    [styles.sidebarButtonMenuClose]: isOpen,
                    [styles.sidebarButtonMenuOpen]: !isOpen,
                })}
                onClick={toggleSidebar}
                data-qa={classnames({
                    'sidebar-button-close': isOpen,
                    'sidebar-button-open': !isOpen,
                })}
            />
            <div className={styles.sidebarMenu}>
                <Menu />
            </div>
            <div className={styles.sidebarFooter}>
                <div className={styles.sidebarSeparator} />
                <Profile isFull={isOpen} />
            </div>
        </div>
    );
};

export default translation(Sidebar);
